import SparkMD5 from 'spark-md5';

const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB chunks

export function computeFileMD5(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const spark = new SparkMD5.ArrayBuffer();
    const reader = new FileReader();
    let offset = 0;

    const readNext = () => {
      const slice = file.slice(offset, offset + CHUNK_SIZE);
      reader.readAsArrayBuffer(slice);
    };

    reader.onload = (e) => {
      spark.append(e.target!.result as ArrayBuffer);
      offset += CHUNK_SIZE;
      if (offset < file.size) {
        readNext();
      } else {
        resolve(spark.end());
      }
    };

    reader.onerror = () => reject(reader.error);
    readNext();
  });
}
